export const THEME_KEY = "tears-gers-theme";

export function readTheme() {
  try { return localStorage.getItem(THEME_KEY) === "light" ? "light" : "dark"; }
  catch { return "dark"; }
}

export function applyTheme(theme) {
  document.documentElement.dataset.theme = theme;
}
